<template>
  <el-table-column
    :label="title"
    :prop="name"
    v-if="!type"
    :align="align"
    :header-align="headerAlign"
    :fixed="fixed"
    :sortable="sortable"
    :formatter="format"
    :render-header="renderHeader"
    :width="width"
    :show-overflow-tooltip="!!showOverflowTooltip"
  >
  </el-table-column>
  <el-table-column
    v-else-if="type === 'expand'"
    :header-align="headerAlign"
    :render-header="renderHeader"
    type="expand"
  >
    <template slot-scope="props">
      <report-table
        v-if="columns.length > 0"
        ref="reportSubTable"
        :tableColumns="columns"
        :tableData="props.row.children"
        :paramsHeight="0"
        indexH="300px"
        reportCode="reportSubTable"
        :subTable="subsubTable"
      >
      </report-table>
      <div
        v-if="template!==''"
        v-html="template(props.row)"
      >
      </div>
    </template>
  </el-table-column>
  <el-table-column
    :label="title"
    :prop="name"
    :fixed="fixed"
    :align="align"
    :header-align="headerAlign"
    :formatter="format"
    :width="buttonWidth"
    v-else-if="type === 'button'"
  >
    <template
      slot-scope="scope"
      v-if="type === 'button'"
    >
      <el-button
        v-for="(button, idx) in buttons"
        v-if="buttonShow(scope.$index, scope.row, button)"
        :key="idx"
        size="mini"
        :disabled="!!button.disabled"
        @click.native.prevent.stop="handleButton(idx, scope.row, button, searchData)">{{button.name}}
      </el-button>
    </template>
  </el-table-column>
  <el-table-column
    :label="title"
    :prop="name"
    :fixed="fixed"
    :render-header="renderHeader"
    :align="align"
    :header-align="headerAlign"
    :width="width"
    v-else-if="type === 'alertconten' || type=== 'goRouter'"
  >
    <template
      slot-scope="scope"
    >
      <span style="color: #5F995F;cursor: pointer;" @click.prevent.stop="alertconten(scope.$index, scope.row)">{{scope.row[name]}}</span>
    </template>
  </el-table-column>

  <el-table-column
    :type=type
    :label="title"
    :prop="name"
    :fixed="fixed"
    :align="align"
    :render-header="renderHeader"
    :header-align="headerAlign"
    :width="width"
    v-else-if="type === 'radio'"
  >
    <template
      slot-scope="scope"
    >
      <el-radio style="cursor: pointer;" @change.native="radio(scope.$index, scope, scope.row)" v-model="radios"
                :label="getLabel(scope)">&nbsp;
      </el-radio>
    </template>
  </el-table-column>
  <el-table-column
    :type=type
    :label="title"
    :prop="name"
    :fixed="fixed"
    :render-header="renderHeader"
    :align="align"
    :header-align="headerAlign"
    :width="width"
    v-else-if="type === 'image'"
  >
    <template
      slot-scope="scope"
    >
      <img style="height: 10vh; width:10vh; cursor: pointer;" @click="showPicture(scope.row[name])"
           :src="scope.row[name]"/>
    </template>
  </el-table-column>
  <el-table-column
    :type=type
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :fixed="fixed"
    :align="align"
    :header-align="headerAlign"
    :selectable="selectAble.bind(this)"
    :width="80"
    :reserve-selection="true"
    v-else-if="type === 'selection'"
  >
  </el-table-column>
  <el-table-column
    v-else-if="type === 'custom'"
    :type="type"
    :label="title"
    :prop="name"
    :fixed="fixed"
    :render-header="renderHeader"
    :width="width"
    :align="align"
    :header-align="headerAlign"
    @addDataBack.native="addDa"
  >
    <template
      slot-scope="scope"
    >
      <custom-column
        :name="name"
        :index="scope.$index"
        :row="scope.row"
        :column="scope.column"
        :searchData="searchData"
        :event="event"
        @addDataBack="addDataBack"
      >&nbsp;
      </custom-column>
    </template>
  </el-table-column>

  <el-table-column
    v-else-if="type === 'expend'"
    :type="type"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :fixed="fixed"
    :width="width"
    :align="align"
    :header-align="headerAlign"
    @addDataBack.native="addDa"
  >
    <template
      slot-scope="scope"
    >
      <expend-column
        :name="name"
        :index="scope.$index"
        :row="scope.row"
        :column="scope.column"
        :event="event"
        @addDataBack="addDataBack"
      >&nbsp;
      </expend-column>
    </template>
  </el-table-column>
  <el-table-column
    v-else-if="type === 'switch'"
    :type="type"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :width="width"
    :align="align"
    :header-align="headerAlign"
  >
    <template slot-scope="scope">
      <!--<el-tooltip :content="'Switch value: ' + scope.row[name]" placement="top">-->
        <el-switch
          @change="handleButton(0, scope.row, switchConfig, searchData)"
          v-model="scope.row[name]"
          :active-color="switchConfig.active.color || '#409EFF' "
          :inactive-color="switchConfig.inactive.color || '#C0CCDA'"
          :active-value="switchConfig.active.value"
          :active-text="switchConfig.active.text"
          :inactive-text="switchConfig.inactive.text">
          :inactive-value="switchConfig.inactive.value">
        </el-switch>
      <!--</el-tooltip>-->
    </template>
  </el-table-column>

    <!--navs导航-->
  <el-table-column
    v-else-if="type === 'navs'"
    :type="type"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :width="width"
    :align="align"
    :header-align="headerAlign"
  >
    <template slot-scope="scope">
      <el-popover
        ref="popover"
        :placement="navsConfig.placement"
        :width="navsConfig.width"
        :trigger="navsConfig.trigger"
      >
          <div v-for="(o,index) in routers" :key="index" class="text item" @click="popoverClick(index, scope, o, searchData)" style="padding: 5px 10px">
            <a  href="javascript:void(0);">{{o.title }}</a>
          </div>
        <span slot="reference" :id="'popover-column'+ scope.$index" class="link-type" >前往</span>
      </el-popover>
    </template>
  </el-table-column>

  <!--有子列-->
  <el-table-column
    v-else-if="type === 'columns'"
    :type="type"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :width="width"
    :align="align"
    :header-align="headerAlign"
  >
    <report-column
      v-for="(column, $index) in subColumns"
      v-if="!column.hidden"
      :key="$index"
      v-bind="column"
      :columnsLen="subColumns.length"
      :searchData="searchData"
    ></report-column>
  </el-table-column>
  <!--下载类型-->
  <el-table-column
    v-else-if="type === 'download'"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :fixed="fixed"
    :width="width"
    :align="align"
    :show-overflow-tooltip="!!showOverflowTooltip"
    :header-align="headerAlign"
  >
    <template slot-scope="scope">
       <span  class="link-type" @click="downloadMethod(0, scope, downLoadConfig, searchData)">{{scope.row[name]}}</span>
    </template>
  </el-table-column>
  <el-table-column
    v-else-if="type === 'dynamicColumnWidth'"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :fixed="fixed"
    :width="width"
    :align="align"
    :resizable="true"
    :show-overflow-tooltip="!!showOverflowTooltip"
    :header-align="headerAlign"
  >
    <template slot-scope="scope">
      <!--<span :id="'dynamicWidth-' + name" style="visibility: hidden">{{maxLengthLabel}}</span>-->
      <pre  :key="scope.$index" style="font-family: inherit;overflow:visible;white-space:nowrap;display: inline-block;width: 100%;padding-left: 2px;padding-right: 2px" v-if="scope.row[name]">
        {{scope.row[name] + dynamicColumnWidth(scope.row[name],scope.$index)}}
      </pre>
    </template>
  </el-table-column>

  <!--other-->
  <el-table-column
    v-else
    :type="type"
    :label="title"
    :prop="name"
    :render-header="renderHeader"
    :fixed="fixed"
    :width="width"
    :align="align"
    :show-overflow-tooltip="!!showOverflowTooltip"
    :header-align="headerAlign"
  >
  </el-table-column>

</template>
<script>
  import customColumn from './base/customColumn.vue'
  import expendColumn from './base/expendColumn.vue'
  import Handlebars from 'handlebars'
  import columnsMixin from '../../../mixins/columnsMixin'
  import reportColumn from './reportColumn'
  export default {
    name: 'report-column',
    components: {
      'custom-column': customColumn,
      'expend-column': expendColumn,
      reportColumn
    },
    mixins: [columnsMixin],
    props: {
      pageSize: {
        type: Number
      },
      index: {
        type: Number
      },
      fixed: {
        type: String
      },
      width: {
        type: String | Number
      },
      hidden: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        defalut: ''
      },
      title: {
        type: String
      },
      name: {
        type: String
      },
      fileName: { // 下载地址的路径名称
        type: String
      },
      formatter: {
        type: String
      },
      showOverflowTooltip: {
        defalut: false
      },
      align: {
        type: String,
        default: 'center'
      },
      buttons: {
        type: Array,
        defalut: []
      },
      sortable: {
        type: Boolean,
        default: false
      },
      isShow: {
        type: String
      },
      event: {
        type: Object
      },
      radioCheckedValue: {
        type: Object
      },
      radioIndex: {
        type: Number
      },
      headerAlign: {
        type: String
      },
      subTable: {
        type: Object,
        default() {
          return {}
        }
      },
      selectable: {
        type: String
      },
      columnsLen: {
        type: Number
      },
      routers: {
        type: Array
      },
      maxWidth: {
        type: Number | String
      },
      switchConfig: {
        type: Object,
        default() {
          return {
            active: {
              'value': true,
              'color': '#13ce66',
              'text': ''
            },
            inactive: {
              'value': false,
              'color': '#ff4949',
              'text': ''

            },
            event: {}
          }
        }
      },
      downLoadConfig: {
        type: Object,
        default() {
          return {
            event: {}
          }
        }
      },
      navsConfig: {
        type: Object,
        default() {
          return {
            placement: "right",
            trigger: "click",
            width: "200"
          }
        }
      },
      subColumns: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      let temp = ''
      if (this.subTable && this.subTable.template) {
        temp = Handlebars.compile(this.subTable.template)
      }
      return {
        dynamicWidth: this.width,
        maxLengthLabel: '',
        showTooltip: true,
        radios: this.radioIndex ? this.radioIndex : null,
        isShowSubTable: false,
        getMetaParams: {},
        columns: this.subTable && this.subTable.columns,
        gridData: [],
        subsubTable: this.subTable && this.subTable.subTable,
        loadingData: false,
        template: temp,
        customWidth: 0
      }
    },
    watch: {
      // maxLengthLabel(val) {
      //   if (val) {
      //     this.$nextTick(() => {
      //       const dom = document.getElementById('dynamicWidth-' + this.name)
      //       dom.innerText = val
      //       const w = dom.offsetWidth
      //       this.dynamicWidth = w + 15
      //       console.warn(this.dynamicWidth, this.title, val)
      //     })
      //   } else {
      //     this.dynamicWidth = this.width
      //   }
      // },
      radioIndex: {
        handler(val) {
          if (val) {
            this.radios = val
          }
        },
        immediate: true,
        deep: true
      }
    },
    created() {
      this.$eventBus.$on('radioStatus', (data) => {
        this.radios = data
      })
      if (this.type === 'columns') {
        this.$bus.$on('report-row-name', (data) => {
          this.$emit('changeSubColumn', this.index, data)
        })
      }
    },
    mounted() {
      this.customWidth = document.getElementById('reportTable') && document.getElementById('reportTable').clientWidth
      window.onresize = () => {
        return (() => {
          if (document.body) {
            this.customWidth = document.getElementById('reportTable') && document.getElementById('reportTable').clientWidth
          }
        })()
      }
    },
    computed: {
      buttonWidth() {
        if (this.width && process.env.PROJECT === 'wwka') {
          return this.width
        } return this.buttons ? this.buttons.length * 100 : this.width
      },
      downloadAName() {
        return this.code + '-download-a-name'
      }
      // dynamicWidth() {
      // const nativeCharRegexp = /[\u4E00-\u9FFF]/; // 中文正则
      // const v = this.maxLengthLabel
      // let resWidth = this.width || 60
      // if (v) {
      // //   let w = 0;
      // //   // 精确计算文字数量中文字符占两个字符
      // //   // for (let i = 0, count = v.length; i < count; i++) {
      // //   //   const char = v[i];
      // //   //   if (nativeCharRegexp.test(char)) {
      // //   //     w += 12;
      // //   //   } else {
      // //   //     w += 12 * 0.6;
      // //   //   }
      // //   // }
      // //   let dom = document.getElementById('dynamicWidth-' + this.name)
      // //   // console.warn(w)
      // //   // dom.innerText = v
      // //   // dom = document.getElementById('dynamicWidth-' + this.name)
      // //   // this.dynamicWidth = w + 15
      // //   w = dom.offsetWidth + 5
      //   // w = 12 * this.maxLengthLabel.length + 8
      //   // console.error(w, this.maxLengthLabel)
      //   if (!this.width) {
      //     resWidth = w
      //   } else if (this.width && w > this.width) {
      //     resWidth = w
      //   }
      //   if (this.maxWidth && w > this.maxWidth) {
      //     resWidth = this.maxWidth
      //   }
      // }
      // return this.width
      // resWidth
      // }
    },
    methods: {
      dynamicColumnWidth(v, index) {
        if (this.count <= this.pageSize) {
          // this.count++
          // if (index === 0) {
          //   this.maxLengthLabel = ''
          //   this.dynamicWidth = this.width
          // }
          // // console.error(index, this.count, this.title)
          //
          // // if (this.isCanComputed) {
          // if (v) {
          //   if (v.length > this.maxLengthLabel.length) {
          //     this.maxLengthLabel = v
          //   }
          // }
          // if (this.count === (this.pageSize - 1)) {
          //   this.isCanComputed = false
          //   const dom = document.getElementById('dynamicWidth-' + this.name)
          //   dom.innerText = this.maxLengthLabel
          //   this.dynamicWidth = dom.offsetWidth + 5
          //   console.error(this.count, this.name, this.dynamicWidth, this.maxLengthLabel)
          // }
          // }
        }
        return ''
      },
      // 下载点击事件
      downloadMethod(index, scope, o, searchData) {
        this.downLoadConfig.event['isDownload'] = true
        this.handleButton(0, scope.row, this.downLoadConfig, searchData)
        // if (scope.row[this.fileName]) {
        //   const a = document.createElement('a')
        //   a.href = '#'
        //   a.download = scope.row[this.fileName] || ''
        //   a.click()
        // }
      },
      realDownLoad(row) {
        if (row[this.fileName]) {
          const a = document.getElementById(this.downloadAName)
          let realPath = row[this.fileName]
          if (process.env.NODE_ENV === 'production') {
            realPath = window.location.protocol + "//" + window.location.host + realPath
          }
          a.href = realPath
          a.download = row[this.name] || ''
          a.click()
        }
      },
      // 表格内popover跳转
      popoverClick(index, scope, o, searchData) {
        const row = scope.row
        document.getElementById('popover-column' + scope.$index).click()
        this.$nextTick(() => {
          this.handleButton(index, row, o, searchData)
        })
      },
      // 点击图片 展示大图 目前针对原译
      showPicture(url) {
        if (process.env.PROJECT === 'outlet') {
          if (url) {
            this.$eventBus.$emit('dialogShow', 2, url)
          }
        }
      },
      selectAble(row, index) {
        if (this.selectable) {
          const Fn = Function
          return new Fn('return ' + this.selectable)()(row, index)
        } else {
          return true
        }
      },
      addDataBack(obj) {
        this.$emit('addDataBack', obj)
      },
      buttonShow(index, row, button) {
        if (button.isShow) {
          const Fn = Function
          return new Fn('return ' + button.isShow)()(index, row, button)
        } else {
          return true
        }
      },
      format(row, column, cellValue, index) {
        if (this.formatter) {
          const Fn = Function
          return new Fn('return ' + this.formatter)()(row, column, cellValue, index)
        } else {
          if (typeof (cellValue) === 'number') {
            return cellValue.toString().replace(/\d+/, function(n) { // 先提取整数部分
              return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) { // 对整数部分添加分隔符
                return $1 + ','
              })
            })
          } else {
            return cellValue
          }
        }
      },
      defaultFormat(row, column, cellValue, index) {
        return cellValue
      },
      getType() {
        return this.type
      },
      alertconten(index, row) {
        switch (this.type) {
          case 'alertconten':
            this.$eventBus.$emit('dialogShow', 1)
            break
          case 'goRouter':
            this.$router.push({
              path: row.path,
              query: {
                id: row.id
              }
            })
            break
          default:
            this.$emit('button-method', event)
            break
        }
      },
      getLabel(scope) {
        return scope.row.key
      },
      radio(index, scope, row) {
        switch (this.type) {
          case 'radio':
            this.radios = row.key
            this.$emit('radioChecked', row)
            this.$emit('radio', row)
            this.$eventBus.$emit('radioChecked', row)
            break
          default:
            this.$emit('button-method', event)
            break
        }
      },
      /* 表头渲染 */
      renderHeader(h, { column, $index }) {
        if (process.env.PROJECT === 'bi') {
          const f = 14
          const constant = 30
          let l = 6
          if (column.label) {
            l = column.label.length <= 5 ? 6 : column.label.length
          }
          column.width = ((f * l + constant) * (this.columnsLen - 1)) <= this.customWidth ? this.customWidth / (this.columnsLen - 1) : f * l + constant
          if (column.label) {
            return (
              <span style={{ flexWrap: 'wrap', textAlgin: 'center' }}>
                <span className='custom_p' style={{ flex: 1, display: 'inline-block' }}>{column.label.split(',')[0]}</span>
                <span className='custom_p' style={{ flex: 1, display: 'inline-block' }}>{column.label.split(',')[1]}</span>
              </span>
            )
          } else {
            return (
              <span style={{ flexWrap: 'wrap', textAlgin: 'center' }}>
              </span>
            )
          }
        } else {
          // const f = 14
          // const constant = 30
          // let l = 6
          // if (column.label) {
          //   l = column.label.length <= 5 ? 6 : column.label.length
          // }
          // column.width = f * l + constant
          if (column.label) {
            return (
              <span style={{ flexWrap: 'wrap', flexDirection: 'row', textAlgin: 'center' }}>
                <span className='custom_p' style={{ flex: 1, display: 'block' }}>{column.label.split(',')[0]}</span>
                <span className='custom_p' style={{ flex: 1, display: 'block' }}>{column.label.split(',')[1]}</span>
              </span>
            )
          } else {
            return (
              <span style={{ flexWrap: 'wrap', textAlgin: 'center' }}>
              </span>
            )
          }
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .hidden-label{
    font-size: 12px;
    position: fixed;
    display: inline-block;
    top: -1100px;
    z-index: 10000;
    right: 100px;
    background-color: red;
    color: green;
    box-sizing: border-box;
    word-break: break-all;
    line-height: 14px;
    overflow:visible;
    white-space:nowrap;
    visibility: hidden;
    padding-left: 2px;
    padding-right: 2px
  }
  .button-operator-area{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/components/reportColumn.vue